import { updateObject } from "../../shared/utility";
import { getDecryptPayload } from "../../system/encryption";
import { emptyString, loginConstants } from "../../constants";
import { globalConstants } from "../../constants/global.constants";

// initializing the token from the browser
const payload = getDecryptPayload();
const token = payload.token || emptyString;

// default state
const initialState = {
  isAuthenticated: token.length > 0,
  jwt: token,
  user: payload?.user || {},
  forgotPasswordResponse: emptyString,
  resetPasswordResponse: emptyString,
  updatePassword: emptyString,
};

// manupilating the state based on actions and returning the state
export const authentication = (state = initialState, action) => {
  switch (action.type) {
    case globalConstants.SUCCESS +
      "_" +
      loginConstants.LOGIN +
      globalConstants.SUCCESS:
      return updateObject(state, {
        jwt: action.data.token,
        user: action.data.user,
        isAuthenticated: true,
      });

    case globalConstants.SUCCESS +
      "_" +
      loginConstants.ADMIN_TOKEN +
      globalConstants.SUCCESS:
      return updateObject(state, {
        jwt: action.data,
        isAuthenticated: true,
      });

    case loginConstants.LOGOUT + globalConstants.SUCCESS:
      return updateObject(state, {
        jwt: emptyString,
        authenticatedUser: null,
        isAuthenticated: false,
      });
    case loginConstants.FORGOT_PASSWORD + globalConstants.SUCCESS:
    case loginConstants.FORGOT_PASSWORD + globalConstants.FAILURE:
    case loginConstants.RESET_FORGOT_PASSWORD_RESPONSE +
      globalConstants.SUCCESS:
      return {
        ...state,
        forgotPasswordResponse: action.data,
      };
    case loginConstants.RESET_PASSWORD + globalConstants.SUCCESS:
      return {
        ...state,
        resetPasswordResponse: action.data,
      };
    case loginConstants.SEND_HELP_MESSAGE + globalConstants.SUCCESS:
    case loginConstants.SEND_HELP_MESSAGE + globalConstants.FAILURE:
      return {
        ...state,
        helpMessageResponse: action.data,
      };
    case loginConstants.UPDATE_PASSWORD + globalConstants.SUCCESS:
    case loginConstants.UPDATE_PASSWORD + globalConstants.FAILURE:
      return {
        ...state,
        updatePassword: action.data,
      };
    case loginConstants.LOGIN_USER + globalConstants.SUCCESS:
      return {
        ...state,
        user: action.data,
      };
    case loginConstants.USER_PROFILE_IMG + globalConstants.SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          logoUrl: action.data?.profilePictureUrl,
        },
      };
    case loginConstants.USER_PROFILE_IMG + globalConstants.FAILURE:
      return {
        ...state,
        user: { ...state.user },
      };
    default:
      return state;
  }
};
